<div class="d-flex flex-column card hover-effect p-3 mb-0" style="width: 100%; height: fit-content;"
  (click)="onCardClicked(entryType)">
    @if (entryType === 'label') {
        <div class="d-flex align-items-center">
            <i class="fa fa-tag fa-xl red"></i>
            <span class="ml-2">{{'integration-apps-instance-provisioning-type-card_label_header' | i18next }}</span>
        </div>
        <span class="subinformations mt-2">{{'integration-apps-instance-provisioning-type-card_label_description' | i18next }}</span>
    } @else if (entryType === 'prompt') {
        <div class="d-flex align-items-center">
            <i class="fa fa-terminal fa-xl red"></i>
            <span class="ml-2">{{'integration-apps-instance-provisioning-type-card_prompt_header' | i18next }}</span>
        </div>
        <span class="subinformations mt-2">{{'integration-apps-instance-provisioning-type-card_prompt_description' | i18next }}</span>
    }
</div>